module.exports = __webpack_public_path__ + "arrow-black-up.png";